import {ExpandMore} from "@mui/icons-material"
import {Box} from "@mui/material"
import React from "react"
const ChevronCell = ({expanded}) => (
    <Box
        sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
        <ExpandMore
            sx={{
                transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
                color: "text.secondary",
            }}
        />
    </Box>
)

export default ChevronCell
